import { render, staticRenderFns } from "./SharedModal.vue?vue&type=template&id=fa0fd52c&scoped=true"
import script from "./SharedModal.vue?vue&type=script&lang=js"
export * from "./SharedModal.vue?vue&type=script&lang=js"
import style0 from "./SharedModal.vue?vue&type=style&index=0&id=fa0fd52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0fd52c",
  null
  
)

export default component.exports